module.exports = __webpack_public_path__ + "ad5db8d6be9b2b58a53f660cbe3fad7c.jpg";